import { ActionTree } from 'vuex';
import { EventsState } from './models';
import { Event } from './models';
import { RootState } from '@/store';
import api from './api';
import { Mutations } from './mutations';
import { ErrorApi } from '@/core/api/ErrorApi';
import Notify from '@/shared/services/Notify/Notify';
import { EventForWidget } from '../components/EventsWidget/models';
import { UserProfile } from '@/modules/users/store/models';
import { PresenceAnswer } from '@/shared/models/PresenceAnswer';
import { getAuthService } from '@/auth';
import { pull } from 'lodash';

export enum Actions {
  FETCH_EVENTS = 'FETCH_EVENTS',
  FETCH_EVENTS_FOR_WIDGET = 'FETCH_EVENTS_FOR_WIDGET',
  FETCH_EVENT = 'FETCH_EVENT',
  SAVE_EVENT = 'SAVE_EVENT',
  DELETE_EVENT = 'DELETE_EVENT',
  UPDATE_PRESENCE = 'UPDATE_PRESENCE',
}

export const actions: ActionTree<EventsState, RootState> = {

  async [Actions.FETCH_EVENTS]({ commit }): Promise<void> {
    commit(Mutations.GET_EVENTS_REQUEST);
    await api.fetchEvents().then(
      (payload: Event[]) => {
        commit(Mutations.GET_EVENTS_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_EVENTS_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_EVENTS_FOR_WIDGET]({ commit }) {
    commit(Mutations.GET_EVENTS_WIDGET_REQUEST);
    await api.fetchEventsForWidget().then(
      (payload: EventForWidget[]) => {
        commit(Mutations.GET_EVENTS_WIDGET_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_EVENTS_WIDGET_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_EVENT]({ commit }, eventId: string) {
    try {
      const eventItem = await api.fetchEvent(eventId);
      return eventItem;
    } catch (error) {
      Notify.errorApi(error);
    }
  },

  async [Actions.SAVE_EVENT]({},  event: Event) {
    await api.saveEvent(event).then(
      () => {
        Notify.success(`Wydarzenie zostało  ${event.id ? 'zaktualizowane' : 'dodane'}.`);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.DELETE_EVENT]({ dispatch },  eventId: number) {
    await api.deleteEvent(eventId).then(
      () => {
        Notify.success(`Wydarzenie zostało usunięte.`);
        dispatch(Actions.FETCH_EVENTS);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.UPDATE_PRESENCE]({ commit },  event: EventForWidget) {
    const userProfile: UserProfile = getAuthService().userProfile;
    await api.updatePresence( {  eventId: event.id, answer: event.answer, userId: userProfile.userId }).then(
      () => {
        switch (event.answer) {
          case PresenceAnswer.Present:
            Notify.success(`Dzięki i do zobaczenia !`);
            event.presentsPeople.push(userProfile.userName);
            event.undecidedsPeople = pull(event.undecidedsPeople, userProfile.userName);
            event.absentsPeople = pull(event.absentsPeople, userProfile.userName);
            break;
          case PresenceAnswer.Undecided:
            Notify.warning(`Ups... Po cichu liczymy, ze ostatecznie się zdecydujesz.`);
            event.presentsPeople = pull(event.presentsPeople, userProfile.userName);
            event.undecidedsPeople.push(userProfile.userName);
            event.absentsPeople = pull(event.absentsPeople, userProfile.userName);
            break;
          case PresenceAnswer.Absent:
            Notify.error(`Buu... no szkoda, ale moze jeszcze zmienisz zdanie. Trzymamy kciuki!`);
            event.presentsPeople = pull(event.presentsPeople, userProfile.userName);
            event.undecidedsPeople = pull(event.undecidedsPeople, userProfile.userName);
            event.absentsPeople.push(userProfile.userName);
            break;
        }
        commit(Mutations.APPLY_EVENT_FOR_WIDGET, event);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

};
